import { useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import gift from '../../../assets/missions/gift.png';
import type { BundleItem } from '../../../stores/rewards/types';
import { formatValueWithK } from '../../../utils/helpers';
import { BundleItemsRenderer } from '../../BundleItemsRenderer/BundleItemsRenderer';
import { CoinWithValue } from '../../CoinWithValue/CoinWithValue';
import { DynamicTooltip } from '../../Tooltip/DynamicTooltip';

import classes from './GiftTooltip.module.scss';

export type GiftTooltipProps = {
  scCoin: number;
  gcCoin: number;
  bundleItems?: BundleItem[] | null;
};

export const GiftTooltip = ({ scCoin, gcCoin, bundleItems }: GiftTooltipProps) => {
  const { t } = useTranslation();
  const iconRef = useRef<HTMLImageElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <img ref={iconRef} alt="reward" className={classes.giftIcon} src={gift} onClick={handleClick} />
      <DynamicTooltip
        arrowAlign="dynamic"
        isOpen={isOpen}
        position="bottom"
        targetRef={iconRef}
        onClose={() => setIsOpen(false)}
      >
        <div className={classes.giftTooltip}>
          <BundleItemsRenderer
            hidePlus
            bundleItems={bundleItems || []}
            className={classes.dailyMissionsGiftTooltipBundleItems}
            direction={'vertical-v2'}
            frbWidgetWidth={35}
            snappyGiftWidgetWidth={30}
          />
          {scCoin > 0 && (
            <CoinWithValue isPile coinSide="top" coinType="SC" valueClassName={classes.coinValue}>
              <span className={classes.coinValue}>{scCoin.toLocaleString()}</span>
            </CoinWithValue>
          )}
          {gcCoin > 0 && (
            <CoinWithValue isPile coinSide="top" coinType="GC" valueClassName={classes.coinValue}>
              <span className={classes.coinValue}>{formatValueWithK(gcCoin, t)}</span>
            </CoinWithValue>
          )}
        </div>
      </DynamicTooltip>
    </>
  );
};
